import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CalsoftNavigationItem } from '../../../navigation.types';
import { CalsoftHorizontalNavigationComponent } from '../../horizontal.component';
import { CalsoftNavigationService } from '../../../navigation.service';

@Component({
    selector       : 'calsoft-horizontal-navigation-divider-item',
    templateUrl    : './divider.component.html',
    styles         : [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CalsoftHorizontalNavigationDividerItemComponent implements OnInit, OnDestroy
{
    // Item
    @Input()
    item: CalsoftNavigationItem;

    // Name
    @Input()
    name: string;

    // Private
    private _calsoftHorizontalNavigationComponent: CalsoftHorizontalNavigationComponent;
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {CalsoftNavigationService} _calsoftNavigationService
     * @param {ChangeDetectorRef} _changeDetectorRef
     */
    constructor(
        private _calsoftNavigationService: CalsoftNavigationService,
        private _changeDetectorRef: ChangeDetectorRef
    )
    {
        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
        // Get the parent navigation component
        this._calsoftHorizontalNavigationComponent = this._calsoftNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._calsoftHorizontalNavigationComponent.onRefreshed.pipe(
            takeUntil(this._unsubscribeAll)
        ).subscribe(() => {

            // Mark for check
            this._changeDetectorRef.markForCheck();
        });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
